// extracted by mini-css-extract-plugin
module.exports = {"bubble-table":"styles-module__bubble-table___VxCiV"};